import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "react-toastify";

function RequestChangesModal({ open, onClose, ticketId, onSubmitted }) {
    const [feedback, setFeedback] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const canSubmit = Boolean(ticketId) && feedback.trim().length >= 5;

    if (!open) return null;

    async function handleSubmit() {
        if (!canSubmit) return;

        setSubmitting(true);
        try {
            // Single endpoint that does not rely on path params
            await axiosInstance.post("/ticket/request-changes", {
                ticketId,
                feedback: feedback.trim()
            });

            toast.success("Request sent.");
            onSubmitted?.();
            onClose();
        } catch (e) {
            console.error(e);
            toast.error("Failed to send request. Please try again.");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4" onClick={onClose}>
            <div
                role="dialog"
                aria-modal="true"
                className="w-full max-w-xl rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-200"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between gap-4 border-b border-slate-200 pb-3">
                    <div className="text-left">
                        <h3 className="text-lg font-semibold text-slate-900">Request changes</h3>
                        <p className="mt-1 text-xs text-slate-600">Ticket ID:{ticketId ?? "N/A"}</p>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-800"
                        aria-label="Close"
                    >
                        ❌
                    </button>
                </div>

                <div className="mt-4 text-left">
                    <label className="mb-1 block text-xs font-semibold text-slate-700">Feedback</label>
                    <textarea
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        rows={6}
                        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                        placeholder="Describe what needs to be changed..."
                    />
                    <p className="mt-1 text-xs text-slate-500">Minimum 5 characters.</p>
                </div>

                <div className="mt-5 flex justify-end gap-2 border-t border-slate-200 pt-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={submitting}
                        className="inline-flex items-center rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-800 hover:bg-slate-200 disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={!canSubmit || submitting}
                        className="inline-flex items-center rounded-full bg-yellow-500 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-600 disabled:opacity-50"
                    >
                        {submitting ? "Sending..." : "Send"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RequestChangesModal;
